import {z} from 'zod';

/** Names make recovery branches explicit while the wire continues to carry catalogue codes. */
const PREFERENCE_REFUSAL_REASON_BY_CODE = {
  'DMS-BC-FPP-0001': 'INVALID_PREFERENCE_PAYLOAD',
  'DMS-BC-FPP-0002': 'PREFERENCE_REVISION_CONFLICT',
  'DMS-BC-FPP-0003': 'NOT_IN_OFFER_STATE',
  'DMS-BC-FPP-0004': 'PRODUCT_UNAVAILABLE',
  'DMS-BC-FPP-0005': 'CONTRACT_CLOSED',
} as const;

export const FinancialProductPreferenceRefusalReasonSchema = z
  .enum([
    'DMS-BC-FPP-0001',
    'DMS-BC-FPP-0002',
    'DMS-BC-FPP-0003',
    'DMS-BC-FPP-0004',
    'DMS-BC-FPP-0005',
  ])
  .transform((code) => PREFERENCE_REFUSAL_REASON_BY_CODE[code]);
export type FinancialProductPreferenceRefusalReason = z.infer<
  typeof FinancialProductPreferenceRefusalReasonSchema
>;
